import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutZoneSuperRegionList extends Layout {
    labelSearchZoneSuperRegion: Label;
    mapRoute: Map;
    sourceZoneSuperRegion: DataSource;
    splitterZoneSuperRegion: Splitter;
    tableZoneSuperRegionList: Table;
}
